import { Outlet } from 'react-router-dom'
import TeacherNav from '@/components/layout/TeacherNav'
import { UnifiedNavigation } from '@/components/navigation/UnifiedNavigation'

export default function TeacherLayout() {
  return (
    <div className="min-h-screen bg-background">
      <UnifiedNavigation preset="teacher" />
      <div className="flex">
        <TeacherNav />
        <main className="flex-1 p-6 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
